/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as JoinRouteImport } from './routes/join'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardTrainingRouteImport } from './routes/dashboard/training'
import { Route as DashboardSocialRouteImport } from './routes/dashboard/social'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'
import { Route as DashboardRewardsRouteImport } from './routes/dashboard/rewards'
import { Route as DashboardPetParksRouteImport } from './routes/dashboard/pet-parks'
import { Route as DashboardNotificationsRouteImport } from './routes/dashboard/notifications'
import { Route as DashboardKnowYourPetRouteImport } from './routes/dashboard/know-your-pet'
import { Route as DashboardFamilyRouteImport } from './routes/dashboard/family'
import { Route as DashboardEpassportRouteImport } from './routes/dashboard/epassport'
import { Route as DashboardDocumentsRouteImport } from './routes/dashboard/documents'
import { Route as DashboardCalendarRouteImport } from './routes/dashboard/calendar'
import { Route as DashboardBookingRouteImport } from './routes/dashboard/booking'
import { Route as DashboardAppointmentsRouteImport } from './routes/dashboard/appointments'
import { Route as DashboardSettingsIndexRouteImport } from './routes/dashboard/settings/index'
import { Route as DashboardSettingsWalletRouteImport } from './routes/dashboard/settings/wallet'
import { Route as DashboardSettingsSecurityRouteImport } from './routes/dashboard/settings/security'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTrainingRoute = DashboardTrainingRouteImport.update({
  id: '/training',
  path: '/training',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSocialRoute = DashboardSocialRouteImport.update({
  id: '/social',
  path: '/social',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRewardsRoute = DashboardRewardsRouteImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPetParksRoute = DashboardPetParksRouteImport.update({
  id: '/pet-parks',
  path: '/pet-parks',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardNotificationsRoute = DashboardNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardKnowYourPetRoute = DashboardKnowYourPetRouteImport.update({
  id: '/know-your-pet',
  path: '/know-your-pet',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardFamilyRoute = DashboardFamilyRouteImport.update({
  id: '/family',
  path: '/family',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardEpassportRoute = DashboardEpassportRouteImport.update({
  id: '/epassport',
  path: '/epassport',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDocumentsRoute = DashboardDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCalendarRoute = DashboardCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBookingRoute = DashboardBookingRouteImport.update({
  id: '/booking',
  path: '/booking',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAppointmentsRoute = DashboardAppointmentsRouteImport.update({
  id: '/appointments',
  path: '/appointments',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsIndexRoute = DashboardSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardSettingsRoute,
} as any)
const DashboardSettingsWalletRoute = DashboardSettingsWalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => DashboardSettingsRoute,
} as any)
const DashboardSettingsSecurityRoute =
  DashboardSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => DashboardSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/dashboard/appointments': typeof DashboardAppointmentsRoute
  '/dashboard/booking': typeof DashboardBookingRoute
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/documents': typeof DashboardDocumentsRoute
  '/dashboard/epassport': typeof DashboardEpassportRoute
  '/dashboard/family': typeof DashboardFamilyRoute
  '/dashboard/know-your-pet': typeof DashboardKnowYourPetRoute
  '/dashboard/notifications': typeof DashboardNotificationsRoute
  '/dashboard/pet-parks': typeof DashboardPetParksRoute
  '/dashboard/rewards': typeof DashboardRewardsRoute
  '/dashboard/settings': typeof DashboardSettingsRouteWithChildren
  '/dashboard/social': typeof DashboardSocialRoute
  '/dashboard/training': typeof DashboardTrainingRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/settings/security': typeof DashboardSettingsSecurityRoute
  '/dashboard/settings/wallet': typeof DashboardSettingsWalletRoute
  '/dashboard/settings/': typeof DashboardSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/dashboard/appointments': typeof DashboardAppointmentsRoute
  '/dashboard/booking': typeof DashboardBookingRoute
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/documents': typeof DashboardDocumentsRoute
  '/dashboard/epassport': typeof DashboardEpassportRoute
  '/dashboard/family': typeof DashboardFamilyRoute
  '/dashboard/know-your-pet': typeof DashboardKnowYourPetRoute
  '/dashboard/notifications': typeof DashboardNotificationsRoute
  '/dashboard/pet-parks': typeof DashboardPetParksRoute
  '/dashboard/rewards': typeof DashboardRewardsRoute
  '/dashboard/social': typeof DashboardSocialRoute
  '/dashboard/training': typeof DashboardTrainingRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/settings/security': typeof DashboardSettingsSecurityRoute
  '/dashboard/settings/wallet': typeof DashboardSettingsWalletRoute
  '/dashboard/settings': typeof DashboardSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/dashboard/appointments': typeof DashboardAppointmentsRoute
  '/dashboard/booking': typeof DashboardBookingRoute
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/documents': typeof DashboardDocumentsRoute
  '/dashboard/epassport': typeof DashboardEpassportRoute
  '/dashboard/family': typeof DashboardFamilyRoute
  '/dashboard/know-your-pet': typeof DashboardKnowYourPetRoute
  '/dashboard/notifications': typeof DashboardNotificationsRoute
  '/dashboard/pet-parks': typeof DashboardPetParksRoute
  '/dashboard/rewards': typeof DashboardRewardsRoute
  '/dashboard/settings': typeof DashboardSettingsRouteWithChildren
  '/dashboard/social': typeof DashboardSocialRoute
  '/dashboard/training': typeof DashboardTrainingRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/settings/security': typeof DashboardSettingsSecurityRoute
  '/dashboard/settings/wallet': typeof DashboardSettingsWalletRoute
  '/dashboard/settings/': typeof DashboardSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/join'
    | '/login'
    | '/dashboard/appointments'
    | '/dashboard/booking'
    | '/dashboard/calendar'
    | '/dashboard/documents'
    | '/dashboard/epassport'
    | '/dashboard/family'
    | '/dashboard/know-your-pet'
    | '/dashboard/notifications'
    | '/dashboard/pet-parks'
    | '/dashboard/rewards'
    | '/dashboard/settings'
    | '/dashboard/social'
    | '/dashboard/training'
    | '/dashboard/'
    | '/dashboard/settings/security'
    | '/dashboard/settings/wallet'
    | '/dashboard/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/join'
    | '/login'
    | '/dashboard/appointments'
    | '/dashboard/booking'
    | '/dashboard/calendar'
    | '/dashboard/documents'
    | '/dashboard/epassport'
    | '/dashboard/family'
    | '/dashboard/know-your-pet'
    | '/dashboard/notifications'
    | '/dashboard/pet-parks'
    | '/dashboard/rewards'
    | '/dashboard/social'
    | '/dashboard/training'
    | '/dashboard'
    | '/dashboard/settings/security'
    | '/dashboard/settings/wallet'
    | '/dashboard/settings'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/join'
    | '/login'
    | '/dashboard/appointments'
    | '/dashboard/booking'
    | '/dashboard/calendar'
    | '/dashboard/documents'
    | '/dashboard/epassport'
    | '/dashboard/family'
    | '/dashboard/know-your-pet'
    | '/dashboard/notifications'
    | '/dashboard/pet-parks'
    | '/dashboard/rewards'
    | '/dashboard/settings'
    | '/dashboard/social'
    | '/dashboard/training'
    | '/dashboard/'
    | '/dashboard/settings/security'
    | '/dashboard/settings/wallet'
    | '/dashboard/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  JoinRoute: typeof JoinRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/training': {
      id: '/dashboard/training'
      path: '/training'
      fullPath: '/dashboard/training'
      preLoaderRoute: typeof DashboardTrainingRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/social': {
      id: '/dashboard/social'
      path: '/social'
      fullPath: '/dashboard/social'
      preLoaderRoute: typeof DashboardSocialRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/rewards': {
      id: '/dashboard/rewards'
      path: '/rewards'
      fullPath: '/dashboard/rewards'
      preLoaderRoute: typeof DashboardRewardsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/pet-parks': {
      id: '/dashboard/pet-parks'
      path: '/pet-parks'
      fullPath: '/dashboard/pet-parks'
      preLoaderRoute: typeof DashboardPetParksRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/notifications': {
      id: '/dashboard/notifications'
      path: '/notifications'
      fullPath: '/dashboard/notifications'
      preLoaderRoute: typeof DashboardNotificationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/know-your-pet': {
      id: '/dashboard/know-your-pet'
      path: '/know-your-pet'
      fullPath: '/dashboard/know-your-pet'
      preLoaderRoute: typeof DashboardKnowYourPetRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/family': {
      id: '/dashboard/family'
      path: '/family'
      fullPath: '/dashboard/family'
      preLoaderRoute: typeof DashboardFamilyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/epassport': {
      id: '/dashboard/epassport'
      path: '/epassport'
      fullPath: '/dashboard/epassport'
      preLoaderRoute: typeof DashboardEpassportRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/documents': {
      id: '/dashboard/documents'
      path: '/documents'
      fullPath: '/dashboard/documents'
      preLoaderRoute: typeof DashboardDocumentsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/calendar': {
      id: '/dashboard/calendar'
      path: '/calendar'
      fullPath: '/dashboard/calendar'
      preLoaderRoute: typeof DashboardCalendarRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/booking': {
      id: '/dashboard/booking'
      path: '/booking'
      fullPath: '/dashboard/booking'
      preLoaderRoute: typeof DashboardBookingRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/appointments': {
      id: '/dashboard/appointments'
      path: '/appointments'
      fullPath: '/dashboard/appointments'
      preLoaderRoute: typeof DashboardAppointmentsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings/': {
      id: '/dashboard/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof DashboardSettingsIndexRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/dashboard/settings/wallet': {
      id: '/dashboard/settings/wallet'
      path: '/wallet'
      fullPath: '/dashboard/settings/wallet'
      preLoaderRoute: typeof DashboardSettingsWalletRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/dashboard/settings/security': {
      id: '/dashboard/settings/security'
      path: '/security'
      fullPath: '/dashboard/settings/security'
      preLoaderRoute: typeof DashboardSettingsSecurityRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
  }
}

interface DashboardSettingsRouteChildren {
  DashboardSettingsSecurityRoute: typeof DashboardSettingsSecurityRoute
  DashboardSettingsWalletRoute: typeof DashboardSettingsWalletRoute
  DashboardSettingsIndexRoute: typeof DashboardSettingsIndexRoute
}

const DashboardSettingsRouteChildren: DashboardSettingsRouteChildren = {
  DashboardSettingsSecurityRoute: DashboardSettingsSecurityRoute,
  DashboardSettingsWalletRoute: DashboardSettingsWalletRoute,
  DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,
}

const DashboardSettingsRouteWithChildren =
  DashboardSettingsRoute._addFileChildren(DashboardSettingsRouteChildren)

interface DashboardRouteChildren {
  DashboardAppointmentsRoute: typeof DashboardAppointmentsRoute
  DashboardBookingRoute: typeof DashboardBookingRoute
  DashboardCalendarRoute: typeof DashboardCalendarRoute
  DashboardDocumentsRoute: typeof DashboardDocumentsRoute
  DashboardEpassportRoute: typeof DashboardEpassportRoute
  DashboardFamilyRoute: typeof DashboardFamilyRoute
  DashboardKnowYourPetRoute: typeof DashboardKnowYourPetRoute
  DashboardNotificationsRoute: typeof DashboardNotificationsRoute
  DashboardPetParksRoute: typeof DashboardPetParksRoute
  DashboardRewardsRoute: typeof DashboardRewardsRoute
  DashboardSettingsRoute: typeof DashboardSettingsRouteWithChildren
  DashboardSocialRoute: typeof DashboardSocialRoute
  DashboardTrainingRoute: typeof DashboardTrainingRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAppointmentsRoute: DashboardAppointmentsRoute,
  DashboardBookingRoute: DashboardBookingRoute,
  DashboardCalendarRoute: DashboardCalendarRoute,
  DashboardDocumentsRoute: DashboardDocumentsRoute,
  DashboardEpassportRoute: DashboardEpassportRoute,
  DashboardFamilyRoute: DashboardFamilyRoute,
  DashboardKnowYourPetRoute: DashboardKnowYourPetRoute,
  DashboardNotificationsRoute: DashboardNotificationsRoute,
  DashboardPetParksRoute: DashboardPetParksRoute,
  DashboardRewardsRoute: DashboardRewardsRoute,
  DashboardSettingsRoute: DashboardSettingsRouteWithChildren,
  DashboardSocialRoute: DashboardSocialRoute,
  DashboardTrainingRoute: DashboardTrainingRoute,
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  JoinRoute: JoinRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
